import { Component } from "@angular/core";
import { SpinnerService } from "../../../app/service/spinner-service/spinner.service";

@Component({
    selector: 'app-spinner-nuevo',
    templateUrl: './spinner-nuevo.component.html',
    styleUrls: ['./spinner-nuevo.component.css'],
})
export class SpinnerNuevoComponent{
    isLoading$ = this.loadingService.isLoading$;
    mensaje$ = this.loadingService.mensaje$;

    constructor(private loadingService: SpinnerService){}
}